// Auth
export const KEY_REFRESH_TOKEN = 'refresh_token'
export const KEY_TOKEN = 'token'
export const KEY_ME = 'me'